// Temporary testing schedule. Restore to 22 and 8 after playtesting.
export const SLEEP_START_HOUR = 4;
export const WAKE_HOUR = 7;

export function isSleeping(nowMs: number): boolean {
  const hour = new Date(nowMs).getHours();
  return hour >= SLEEP_START_HOUR && hour < WAKE_HOUR;
}
